import React from 'react'

const ActionButtons = ({ 
  onNew, 
  onBack, 
  onRestart, 
  onLike, 
  onSave, 
  onShare,
  onSlider,
  sliderActive = false,
  showSlider = false,
  canGoBack = true,
  canRestart = true,
  onBrush,
  brushActive = false,
  onSegmentation,
  segmentationActive = false,
  disabled = false
}) => {
  return (
    <div className="edit-action-buttons">
      {/* Brush/Mask tool - disabled when slider is active */}
      <button
        className={`action-btn-circle ${brushActive ? 'active' : ''}`}
        onClick={onBrush}
        title="Magic Brush"
        data-tooltip="Magic Brush"
        disabled={sliderActive || segmentationActive}
      >
        <i className="fas fa-paint-brush"></i>
      </button>
      
      {/* Magic Touch tool - disabled when brush or slider is active */}
      <button
        className={`action-btn-circle ${segmentationActive ? 'active' : ''}`}
        onClick={onSegmentation}
        title="Magic Touch"
        data-tooltip="Magic Touch"
        disabled={sliderActive || brushActive}
      >
        <i className="fas fa-hand-pointer"></i>
      </button>
      
      {/* New button - ALWAYS active */}
      <button
        className="action-btn-circle new-btn"
        onClick={onNew}
        title="New"
        data-tooltip="New"
      >
        <i className="fas fa-plus"></i>
      </button>
      
      {/* Slider button - disabled when brush is active or no images to compare */}
      <button
        className={`action-btn-circle slider-btn ${sliderActive ? 'active' : ''}`}
        onClick={onSlider}
        title="Before/After Comparison"
        data-tooltip="Compare"
        disabled={!showSlider || brushActive}
      >
        <i className="fas fa-exchange-alt"></i>
      </button>
      
      <button
        className="action-btn-circle back-btn"
        onClick={onBack}
        title="Back"
        data-tooltip="Back"
        disabled={!canGoBack}
      >
        <i className="fas fa-undo"></i>
      </button>
      
      {/* Restart button - ALWAYS active when there's history */}
      <button
        className="action-btn-circle restart-btn"
        onClick={onRestart}
        title="Restart"
        data-tooltip="Restart"
        disabled={!canRestart}
      >
        <i className="fas fa-sync-alt"></i>
      </button>
      
      <button
        className="action-btn-circle like-btn"
        onClick={onLike}
        title="Like"
        data-tooltip="Like"
      >
        <i className="fas fa-thumbs-up"></i>
      </button>
      
      <button
        className="action-btn-circle save-btn"
        onClick={onSave}
        title="Save"
        data-tooltip="Save"
      >
        <i className="fas fa-save"></i>
      </button>
      
      <button
        className="action-btn-circle share-btn"
        onClick={onShare}
        title="Share"
        data-tooltip="Share"
      >
        <i className="fas fa-share"></i>
      </button>
    </div>
  )
}

export default ActionButtons